import angular from 'angular'
import template from '../../views/common/template.html'
import baseData from './baseData'
import FOManage from './fillOpenManage'
import billManage from './billManage'
import stock from './stock'
import taxFilling from './taxFilling'
import fullElectricInvoice from './fullElectricInvoice'
import invoicePool from './invoicePool'

export default angular
    .module('outputManage', [baseData, FOManage, billManage, stock, taxFilling, fullElectricInvoice, invoicePool])
    .config([
        '$stateProvider',
        ($stateProvider) => {
            $stateProvider.state('outputManage', {
                abstract: true,
                url: '/outputManage',
                template,
                title: '销项管理',
            })
        },
    ]).name



// WEBPACK FOOTER //
// ./src/app/outputManage/index.js